<ng-template class="theme-modal" #quickView let-modal>
    <div class="modal-content quick-view-modal">
        <div style="padding: 2rem;" class="modal-body">
            <button type="button" class="close float-end border-0" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="row">
                <div class="col-lg-6  col-xs-12">
                    <div class="quick-view-img">
                        <img [src]="ImageSrc ? ImageSrc : product.images[0].imageUrl" [alt]="product.images[0].id"
                             class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-6 rtl-text">
                    <div class="product-right">
                        <h2>{{ product.name | titlecase }}</h2>
                        <h3>{{ product.cost - (product.cost * product.discountPercent / 100) | currency: 'VND'}}
                            <del *ngIf="product?.discountPercent > 0"><span class="money">
                                    {{ product.cost | currency: 'VND' }}
                                </span></del>
                        </h3>
                        <div class="d-flex justify-content-center flex-column flex-wrap box-cover">
                            <div class="text-name">Chi tiết:</div>
                            <div class="text-desc fw-normal">{{ product.description.substring(0, 200) + '...' }}</div>
                        </div>

                        <div class="d-flex align-items-center flex-wrap box-cover">
                            <div class="text-name">Loại:</div>
                            <div *ngFor="let category of product.categories">
                                <div class="text-category">{{category.name}}</div>
                            </div>
                        </div>

                        <div class="d-flex align-items-center box-cover">
                            <div class="text-name">Tên shop:</div>
                            <div class="text-desc"> {{ product.shop.name }} </div>
                        </div>

                        <div class="d-flex align-items-center box-cover">
                            <div class="text-name">Đánh giá:</div>
                            <div class="text-desc">{{product.averageRating}} <i class="fa fa-star" style="color: gold;"
                                                                                aria-hidden="true"></i></div>
                        </div>
                        <div class="d-flex align-items-center box-cover">
                            <div class="text-name">Số lượng:</div>
                            <div class="qty-box">
                                <div class="input-group">
                                    <span class="input-group-prepend">
                                        <button type="button" class="btn quantity-left-minus" data-type="minus"
                                                (click)="decrement()">
                                            <i class="ti-angle-left"></i>
                                        </button>
                                    </span>
                                    <input type="text" name="quantity" class="form-control input-number"
                                           [value]="counter"
                                           disabled>
                                    <span class="input-group-prepend">
                                        <button type="button" class="btn quantity-right-plus" data-type="plus"
                                                (click)="increment()">
                                            <i class="ti-angle-right"></i>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="product-buttons d-flex justify-content-around align-items-center">
                        <a href="javascript:void(0)" class="btn btn-solid" [class.disabled]="counter > product.stock"
                           (click)="addToCart(product)">Thêm ngay</a>
                        <a [routerLink]="['/shop/products', product.id]" class="btn btn-solid">Xem chi
                            tiết</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
